"use strict";
import dayjs from 'dayjs'

require("babel-polyfill");
require("./ie-polyfills");

// require("./ibox")(".i-box_gallery");

let $ = require("./jquery");
require("./iislider")($);

// const tabs = require("./tabs")
/* usage: tabs({
    widget: document.querySelectorAll(".bare-b_tabs"),
    options: {
        switcherClassName: "bare-b_tabs-switch",
        tabClassName: "bare-b_tab",
        callbackAfterCreate: function (widget) {
            widget.addEventListener("tabs:click", function (event) {
                // example
            })
        }
    }
});*/

 const forms = require("./forms");
// usage: forms(".af-form_v2");

 const onBlock = require("./onblock");
// usage: onBlock(selector, callback(results))

 const autoForms = require("./autoforms");
// usage: autoForms.init(node, options)

// const metrika = require("./metrika")(24556598);
// usage: metrika.reachGoal(goal, cb)

 const maskedInput = require("./maskedinput");
// usage: maskedInput(node).mask("+7 (999) 999-99-99");

// const sliderUnified = require("./sliderUnified.js");
/* usage:
    sliderUnified({
    widget: document.querySelectorAll(".bare-b_slides"),
    options: {
        amountToSlide: 1,
        cyclic: false,
        autoSlide: false,
        viewportLength: 7
    }
});*/

// const richDrop = require("./richdrop")
// usage: richDrop(node); // node - single htmlElement

// const suggestInput = require("./suggestInput");
// usage suggestInput(node); // node - single htmlElement

// const Popup = require("./popup");
/* usage:
    var popup = new Popup(`
    <div class="bare-b_registered-persons-popup--content">
        <div class="popup-title">Список участников</div>
        <div class="popup-table">
        <div class="popup-table-head">
            <div class="table-head-item item-number">№</div>
            <div class="table-head-item item-person-name">Участник</div>
            <div class="table-head-item item-sport-rank">Разряд</div>
            <div class="table-head-item item-region">Регион</div>
            <div class="table-head-item item-club">Организация</div>
        </div>
        <div class="popup-table-items">
        ${JSON.parse(data).map(function (item, index) {
            return `<div class=table-item>"
                <div class="table-item-cell item-number">(index1)</div>
                <div class="table-item-cell item-person-name">item.surname<br>item.name</div>
                <div class="table-item-cell item-sport-rank">item.sport_rank</div>
                <div class="table-item-cell item-region">item.region</div>
                <div class="table-item-cell item-club">item.club_title</div>
                </div>`
        }).join()}
        </div>
        </div>
    </div>`);
popup.show();*/
const ScrollMagic = require("../../../node_modules/scrollmagic/scrollmagic/uncompressed/ScrollMagic");
const trigger = require("./trigger");
require('../../../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
// const gsap = require("gsap");
const TweenMax = require("../../../node_modules/gsap/src/uncompressed/TweenMax");
const TimelineMax = require("../../../node_modules/gsap/src/uncompressed/TimelineMax");

onBlock("form", function (nodes) {
    forms("form");
    $.each(nodes, function () {
       let options = {

       };
       autoForms.init(this, options)
    })
});

onBlock(".ch-b_trio-slider", function (widgets) {
    $(widgets).iislider(
        {
            slides:[
                {
                    small_image:"/app/build/template/trio-classic.jpg",
                    big_image:"/app/build/template/trio-classic.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-hunter.jpg",
                    big_image:"/app/build/template/trio/hanter.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-activefish.jpg",
                    big_image:"/app/build/template/trio/activfish.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-vozduh.jpg",
                    big_image:"/app/build/template/trio/vozduh.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-rosgaz.jpg",
                    big_image:"/app/build/template/trio/rgaz.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-nevatrade.jpg",
                    big_image:"/app/build/template/trio/neva.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-parketbar.jpg",
                    big_image:"/app/build/template/trio/parket.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-pravda.jpg",
                    big_image:"/app/build/template/trio/pravda.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-slt.jpg",
                    big_image:"/app/build/template/trio/slt.jpg",
                    info_text: ""
                },
                {
                    small_image:"/app/build/template/previews/preview-sharman.jpg",
                    big_image:"/app/build/template/trio/sharman.jpg",
                    info_text: ""
                },
            ],
            animationType:"new",
            ribbonType   :"image",
            autoSlide: false,
            animationDuration     : 200,
            autoSlideDuration: 4000
        }
    );
});

onBlock(".ch-e_phone-input input", function (nodes) {
    $.each(nodes, function () {
        maskedInput(this).mask("+7 (999) 999-99-99");
    });
});

onBlock(".ch-b_estimate-new-year", function (widget) {
    let newYear = dayjs().endOf('year'),
        estimate = Math.floor((newYear-Date.now())/1000/60/60/24);

    if (~~estimate<10) { 
        estimate = "00"+estimate 
    } else if (~~estimate<100) {
        estimate = "0"+estimate 
    }
    widget[0].innerHTML = require("./templates/estimate")(estimate);
});

onBlock(".ch-r_header", function (widget) {
    // init controller
    let controller = new ScrollMagic.Controller();
    // create a scene
    new ScrollMagic.Scene({
        duration: 900,    // the scene should last for a scroll distance of 500px
        triggerElement: "#winter-anim"
    })
        .setTween(new TweenMax.to("#winter-anim", 1, {
            css: {
              "background-position": "50% 250px"
            },
            ease: Linear.easeNone
        }))
        .triggerHook(0.28)
        .addTo(controller);

});

onBlock(".ch-b_section.cool", function (widget) {
    // init controller
    let controller = new ScrollMagic.Controller();
    // create a scene
    let tl = new TimelineMax({
        tweens: [
            new TweenMax.to("#animated-sphere1", 1, {y: -150, ease: Linear.easeNone}),
            new TweenMax.to("#animated-sphere2", 1, {y: -200, ease: Linear.easeNone}),
            new TweenMax.to("#animated-star", 1, {y: -250, ease: Linear.easeNone}),
            new TweenMax.set(".hidden-text", {className: "hidden-text hidden", delay: 0.6})
        ]
    });

    new ScrollMagic.Scene({
        duration: 1000,    // the scene should last for a scroll distance of 500px
        triggerElement: "#spheres-anim"
    })
        .setTween(tl)
        .triggerHook(0.7)
        .addTo(controller);

});

onBlock(".ch-b_section.from-null", function (widget) {
    trigger({
        widget: widget[0],
        type: "reach",
        triggerAfterEventFiresCount: -1,
        callback: function () {
            TweenMax.staggerTo(".step-image img", 1, {opacity: 1, y:100}, 0.5);
        }
    });
});

onBlock(".ch-b_section.alcohol", function (widget) {
    // init controller
    let controller = new ScrollMagic.Controller();
    // create a scene

    new ScrollMagic.Scene({
        duration: 1000,    // the scene should last for a scroll distance of 500px
        triggerElement: "#alcohol-anim"
    })
        .setTween(new TweenMax.to("#animated-bottle", 1, {y: -150, ease: Linear.easeNone}))
        .triggerHook(0.7)
        .addTo(controller);

});